import { render, staticRenderFns } from "./VkForm.vue?vue&type=template&id=3cd742fa&"
import script from "./VkForm.vue?vue&type=script&lang=ts&"
export * from "./VkForm.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports